package com.hyperether.goodjob.scenes.dashboard

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Icon
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.small_gray_map
import com.hyperether.goodjob.scenes.components.CircleWithInitial
import com.hyperether.goodjob.theme.AddEmployeeInputColor
import com.hyperether.goodjob.util.StatusColor
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import org.jetbrains.compose.resources.painterResource

@Composable
fun MapJobCard(
    title: String,
    address: String,
    status: String,
    employeeName: String? = null,
    verticalPadding: Dp = 40.toScaleDp(),
    horizontalPadding: Dp = 10.toScaleDp(),
    shadow: Boolean = false,
    modifier: Modifier = Modifier
) {
    Box(
        modifier = Modifier.width(300.toScaleDp()).then(modifier)
            .padding(vertical = verticalPadding, horizontal = horizontalPadding)
    ) {

        Row(
            modifier = Modifier.width(300.toScaleDp())
                .background(Color.White, shape = RoundedCornerShape(12.toScaleDp()))
                .then(
                    if (shadow) Modifier.border(
                        1.toScaleDp(),
                        Color.Gray,
                        shape = RoundedCornerShape(12.toScaleDp())
                    ) else Modifier
                )
                .padding(12.toScaleDp()),
            horizontalArrangement = Arrangement.SpaceBetween
        ) {

            Column(modifier = Modifier.weight(1f)) {
                Row(
                    modifier = Modifier.padding(bottom = 8.toScaleDp()),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Text(
                        text = title,
                        color = Color.Black,
                        fontWeight = FontWeight.Bold,
                        fontSize = 18.toScaleSp(),
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                    if (employeeName != null) {
                        Spacer(modifier = Modifier.width(8.toScaleDp()))
                        Box(
                            modifier = Modifier
                                .size(16.toScaleDp())
                                .background(
                                    color = StatusColor.getStatusColor(status),
                                    shape = CircleShape
                                )
                        )
                    }
                }
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(
                        painter = painterResource(Res.drawable.small_gray_map),
                        contentDescription = "Map icon",
                        modifier = Modifier.padding(end = 4.toScaleDp())
                    )
                    Text(
                        text = address,
                        fontSize = 14.toScaleSp(),
                        color = Color.Gray,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                }
            }

            if (employeeName == null)
                Box(
                    modifier = Modifier
                        .size(16.toScaleDp())
                        .background(
                            color = StatusColor.getStatusColor(status),
                            shape = CircleShape
                        )
                )
            employeeName?.let {
                CircleWithInitial(it)
            }
        }
    }
}

@Composable
fun PlacesJobCard(
    title: String,
    status: String,
    date: String,
    siteName: String,
    employeeName: String?,
    onClick: () -> Unit
) {
    Box(modifier = Modifier.width(300.toScaleDp())
        .padding(vertical = 20.toScaleDp(), horizontal = 16.toScaleDp())
        .clickable {
            onClick()
        }
    ) {
        Row(
            modifier = Modifier.fillMaxWidth()
                .background(Color.White, shape = RoundedCornerShape(12.toScaleDp()))
                .border(
                    1.toScaleDp(),
                    AddEmployeeInputColor,
                    shape = RoundedCornerShape(12.toScaleDp())
                )
                .padding(12.toScaleDp()),
            horizontalArrangement = Arrangement.SpaceBetween
        ) {

            Column(
                modifier = Modifier
                    .weight(1f)
                    .padding(end = 12.toScaleDp())
            ) {
                Row {
                    Column(
                        modifier = Modifier.weight(1f)
                    ) {
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.SpaceBetween
                        ) {
                            Text(
                                text = title,
                                color = Color.Black,
                                fontWeight = FontWeight.Bold,
                                fontSize = 18.toScaleSp(),
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis,
                                modifier = Modifier.weight(1f)
                            )
                            Spacer(modifier = Modifier.width(8.toScaleDp()))
                            Box(
                                modifier = Modifier
                                    .size(16.toScaleDp())
                                    .background(
                                        color = StatusColor.getStatusColor(status),
                                        shape = CircleShape
                                    )
                            )
                        }

                        Text(
                            text = siteName,
                            fontSize = 14.toScaleSp(),
                            color = Color.Gray,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                        Text(
                            text = date,
                            fontSize = 14.toScaleSp(),
                            color = Color.Gray,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                    }
                }
            }

            CircleWithInitial(employeeName, size = 40.toScaleDp())
        }
    }
}